import { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

export const useIsIframed = () => {
  const [isIframed, setIsIframed] = useState(false);

  useEffect(() => {
    const inIframe = window.self !== window.top;
    setIsIframed(inIframe);
  }, []);

  return isIframed;
};

export const usePostMessageOnRouteChange = () => {
  const location = useLocation();
  const isIframed = useIsIframed();

  useEffect(() => {
    if (isIframed) {
      // Communicate the URL change to PHQ
      window.parent.postMessage(
        {
          action: "switchRoute",
          route: location.pathname
        },
        "*"
      );
    }
  }, [location.pathname]);
};

export const useParentRouteChangeListener = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const handleMessage = event => {
      if (
        event.data.action === "switchRoute" &&
        event.data.route !== location.pathname
      ) {
        history.replace(event.data.route);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [location.pathname, history]);
};
